const DsArticle = window.DsArticle || {
  _initialized: false,
  
  // 1. SCROLL LOCK
  ScrollLock: {
    scrollTop: 0,
    isLocked: false,
    lock() {
      if(this.isLocked) return;
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollBarWidth}px`;
      
      this.scrollTop = window.scrollY;
      document.body.classList.add('ds-ui-locked');
      document.body.style.top = `-${this.scrollTop}px`;
      this.isLocked = true;
    },
    unlock() {
      if(!this.isLocked) return;
      document.body.classList.remove('ds-ui-locked');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('padding-right'); 
      window.scrollTo(0, this.scrollTop);
      this.isLocked = false;
    }
  },

  // 2. SMOOTH SCROLL ENGINE (Optimized 2026-01-30)
  // FIX: Changed from easeInOutQuart to easeOutCubic for snappier response
  // FIX: Reduced duration from 1200-3000ms to 400-800ms for better UX
  SmoothScroll: {
    to(element) {
      if(!element) return;
      const targetPos = element.getBoundingClientRect().top + window.pageYOffset - 120;
      const startPos = window.pageYOffset;
      const distance = targetPos - startPos;
      const absDistance = Math.abs(distance);

      // Faster, more responsive duration (400-800ms instead of 1200-3000ms)
      const duration = Math.min(800, Math.max(400, 300 + (absDistance * 0.15)));

      let startTime = null;
      // easeOutCubic: Fast start, smooth deceleration (like iOS momentum)
      const easeOutCubic = (t, b, c, d) => {
        t /= d;
        t--;
        return c * (t * t * t + 1) + b;
      };

      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeOutCubic(timeElapsed, startPos, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      };
      requestAnimationFrame(animation);
    }
  },

  // 3. AUDIO
  Audio: {
    init() {
      const audio = document.getElementById('DsGlobalAudio');
      const controllers = document.querySelectorAll('.ds-audio-controller');
      let isPlaying = false;

      const updateUI = (active) => {
        isPlaying = active;
        controllers.forEach(c => {
          const playIcon = c.querySelector('.ds-icon-play');
          const pauseIcon = c.querySelector('.ds-icon-pause');
          if(playIcon) playIcon.style.display = active ? 'none' : 'block';
          if(pauseIcon) pauseIcon.style.display = active ? 'block' : 'none';
        });
      };

      controllers.forEach(c => {
        c.addEventListener('click', (e) => {
          e.stopPropagation();
          const src = c.dataset.source;
          const url = c.dataset.url;

          if (src === 'auto') {
            if (window.speechSynthesis.speaking) {
              window.speechSynthesis.cancel();
              updateUI(false);
            } else {
              updateUI(true);
              const text = document.getElementById('DsArticleContent').innerText;
              const ut = new SpeechSynthesisUtterance(text);
              ut.lang = 'de-DE';
              ut.onend = () => updateUI(false);
              ut.onerror = () => updateUI(false);
              window.speechSynthesis.speak(ut);
            }
          } else if (src === 'manual' && url) {
            if (isPlaying) {
              audio.pause();
              updateUI(false);
            } else {
              updateUI(true);
              if (audio.src !== url) audio.src = url;
              audio.play();
            }
          }
        });
      });

      if(audio) {
        audio.onended = () => updateUI(false);
        audio.onpause = () => updateUI(false);
      }
    }
  },

  // 4. UI
  UI: {
    init() {
      const modal = document.getElementById('DsPreviewModal');
      const content = document.getElementById('DsAjaxContent');
      const previewBody = document.getElementById('DsPreviewContentArea');
      const fullBtn = document.getElementById('DsPreviewFullBtn');
      const loader = document.getElementById('DsLoader');

      // SECURITY FIX B-JS-01 (CVSS 7.4) - 2026-05-11
      // Script-Rekreation aus same-origin HTML entfernt: war Stored-XSS-Amplifier
      // fuer Blog-body_html / Produkt-description.
      const executeSafe = (container) => {
        try {
          container.querySelectorAll('script').forEach(s => s.remove());
        } catch (e) {}
        if (window.Trustpilot && window.Trustpilot.loadFromElement) window.Trustpilot.loadFromElement(container);
        if (window.jdgm && window.jdgm.widget) window.jdgm.widget.load();
        if (window.Loox) window.Loox.refresh();
        window.dispatchEvent(new Event('resize'));
      };

      const openModal = (url) => {
        DsArticle.ScrollLock.lock();
        modal.classList.add('active');
        loader.classList.add('active');
        previewBody.classList.remove('ready'); 
        content.innerHTML = '';
        fullBtn.href = url;

        fetch(url).then(r => r.text()).then(html => {
           const doc = new DOMParser().parseFromString(html, 'text/html');
           let body = doc.getElementById('MainContent') || doc.querySelector('main') || doc.querySelector('.shopify-section') || doc.body;
           
           body.querySelectorAll('img').forEach(img => {
             if(img.dataset.src) img.src = img.dataset.src;
             if(img.dataset.srcset) img.srcset = img.dataset.srcset;
             img.classList.remove('lazyload', 'lazy');
             img.style.opacity = '1';
           });

           content.innerHTML = body.innerHTML;
           previewBody.scrollTop = 0;
           executeSafe(content);
           loader.classList.remove('active');
           setTimeout(() => { previewBody.classList.add('ready'); }, 50);
        }).catch(() => {
           content.innerHTML = '<p style="text-align:center;padding:40px">Inhalt konnte nicht geladen werden.</p>';
           loader.classList.remove('active');
           previewBody.classList.add('ready');
        });
      };

      document.addEventListener('click', (e) => {
         const trigger = e.target.closest('.ds-trigger-preview, .ds-rte a');
         if(!trigger) return;
         const href = trigger.dataset.url || trigger.getAttribute('href');
         let isInternal = false;
         if(href && !href.startsWith('#') && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
            if(href.startsWith('/')) isInternal = true;
            else { try { isInternal = new URL(href, location.origin).hostname === location.hostname; } catch(e){} }
         }
         if(isInternal) {
            e.preventDefault(); e.stopPropagation(); openModal(href);
         }
      }, true);

      const closePreview = () => {
         modal.classList.remove('active');
         DsArticle.ScrollLock.unlock();
         setTimeout(() => { content.innerHTML = ''; previewBody.classList.remove('ready'); }, 400);
      };
      
      const closeBtn = document.getElementById('DsPreviewClose');
      if(closeBtn) closeBtn.addEventListener('click', closePreview);
      modal.addEventListener('click', (e) => { if(e.target === modal) closePreview(); });

      document.addEventListener('click', (e) => {
         if(e.target.closest('a[href^="#chapter-"]')) {
            e.preventDefault();
            const id = e.target.closest('a').getAttribute('href').substring(1);
            const el = document.getElementById(id);
            if(el) DsArticle.SmoothScroll.to(el);
         }
      });
    }
  },

  // 5. CONTENT
  Content: {
    init() {
      const container = document.getElementById('DsArticleContent');
      if(!container) return;
      
      const headings = container.querySelectorAll('h2');
      let tocHTML = '';
      headings.forEach((h, i) => {
         if(h.innerText.trim()) {
            h.id = 'chapter-' + i;
            tocHTML += `<a href="#chapter-${i}" class="ds-toc-link">${h.innerText}</a>`;
         }
      });
      
      if(tocHTML) {
         const desktopNav = document.getElementById('DsDesktopTocNav');
         if(desktopNav) desktopNav.innerHTML = tocHTML;
      } else {
         const sidebar = document.querySelector('.ds-sidebar-col');
         if(sidebar) sidebar.style.display = 'none';
      }

      container.querySelectorAll('table').forEach(t => {
         if(!t.parentNode.classList.contains('ds-table-wrapper')) {
            const c = document.createElement('div');
            c.className = 'ds-table-container';
            const w = document.createElement('div');
            w.className = 'ds-table-wrapper';
            t.parentNode.insertBefore(c, t);
            c.appendChild(w);
            w.appendChild(t);
            w.addEventListener('scroll', () => c.classList.add('scrolled'), {once: true, passive: true});
         }
      });
    }
  },

  init() {
    if (this._initialized) return;
    this._initialized = true;
    
    this.Content.init();
    this.UI.init();
    this.Audio.init();
    
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => DsArticle.init());
} else {
  DsArticle.init();
}
